import type { TourDefinition } from '../types'

export const dashboardTour: TourDefinition = {
  id: 'dashboard',
  title: 'Dashboard Tour',
  description: 'Understand the key metrics and sections of your tenant dashboard.',
  icon: 'LayoutDashboard',
  route: '/tenant/dashboard',
  estimatedMinutes: 2,
  steps: [
    {
      element: '[data-tour-id="dashboard-stats"]',
      popover: {
        title: 'Platform Overview',
        description: 'These cards give you a quick snapshot of your workflows, executions, success rate, and month-to-date cost.',
      },
      aiContext: 'What do the dashboard stat cards show and how are they calculated?',
    },
    {
      element: '[data-tour-id="execution-status"]',
      popover: {
        title: 'Execution Status',
        description: 'A breakdown of all workflow runs by status. Click any status to filter your executions list.',
      },
      aiContext: 'What causes executions to stay in Pending or Queued state?',
    },
    {
      element: '[data-tour-id="recent-executions"]',
      popover: {
        title: 'Recent Runs',
        description: 'The last 10 workflow executions across all workflows. Click any row to see full execution details and logs.',
      },
      aiContext: 'How do I investigate a failed workflow execution from the dashboard?',
    },
    {
      element: '[data-tour-id="orchestration-chains"]',
      popover: {
        title: 'Orchestration Chains',
        description: 'Active orchestration chains linking multiple workflows or engines appear here. Click to view the full chain graph.',
      },
      aiContext: 'What is an orchestration chain and how do I create one?',
    },
  ],
}
